import React from 'react';
import PropTypes from 'prop-types';
import WizardInput from '../Input';
import TextArea from '../../Input/TextArea';
import styles from './styles.less';

const Title = ({ t, description, setValue }) => (
  <>
    <WizardInput title={t('course.create.wizard.step4_2')} hint={t('wizard.hint.description')}>
      <TextArea
        className={styles.wizardTextarea}
        value={description}
        onChange={e => setValue(e.target.value, 'description')}
        placeholder={t('course.edit.description.placeholder')}
        name="wizard_description"
      />
    </WizardInput>
  </>
);

Title.propTypes = {
  setValue: PropTypes.func,
  t: PropTypes.func,
  description: PropTypes.string,
};

Title.defaultProps = {
  setValue: () => {},
  t: () => {},
  description: '',
};

export default Title;
